import { useEffect, useState } from 'react';

const useTicker = (intervalMs = 1000) => {
  const [tick, setTick] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setTick(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return tick;
};

export default useTicker;
